import { Card, Text, InlineStack, Box } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';

interface AnalyticsCardProps {
  title: string;
  value: string | number;
  change?: string | number;
  trend?: 'up' | 'down' | 'neutral';
  icon?: React.ReactNode;
}

export function AnalyticsCard({ title, value, change, trend, icon }: AnalyticsCardProps) {
  const { t } = useTranslation();
  const changeColor = trend === 'up' ? 'success' : trend === 'down' ? 'critical' : 'subdued';

  return (
    <Card>
      <Box padding="400">
        <InlineStack align="space-between" blockAlign="start">
          <Box>
            <Text as="p" variant="bodyMd" tone="subdued">
              {title}
            </Text>
            <Text as="p" variant="headingLg" fontWeight="bold">
              {value}
            </Text>
            {change !== undefined && (
              <Text as="p" variant="bodySm" tone={changeColor}>
                {change} {t('analytics.fromLastPeriod')}
              </Text>
            )}
          </Box>
          {icon && <Box>{icon}</Box>}
        </InlineStack>
      </Box>
    </Card>
  );
}
